export default __webpack_public_path__ + "static/media/gift.3f35e2a5.svg";